import {
  TableContainer,
  TableHead,
  TableBody,
  withWidth,
} from "@material-ui/core";
import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import { StyledFAB } from "../../components/CustomStyles/CustomFAB";
import BootstrapInputSearch from "../../components/InputSearch/BootstrapInputSearch";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import IzyTabsPanel from "../../components/IzyTabsPanel";
import DateRangePickerFilter from "../../components/Filters/DateRangePicker";
import moment from "moment-timezone";
import {
  IZYTable,
  IZYTableCell,
  IZYTableRow,
} from "../../components/CustomStyles/CustomTable";
import { useQuery, useMutation, QueryClient } from "react-query";
import OrderService from "../../Services/OrderService";
import { handleError } from "../../components/Utils/Utils";
import { ListRowLoadingPanel, ListRowPanel } from "./parts/NewListPanel";
import DetailPanel from "./parts/DetailPanel";
import { confirm } from "../../components/ConfirmationDialog/ConfirmationDialog";
import { notifUtils } from "../../components/NotifUtils/NotifUtils";
import { showQRCodeDialog } from "./parts/QRCodeDialog";
import { showPrintOrderDialog } from "./parts/PrintOrderDialog";
// import "moment-timezone";

const user = JSON.parse(localStorage.getItem("user"));
const NewOrder = ({ width, params, ...props }) => {
  const access = params;
  const [arrStatus, setArrStatus] = React.useState([
    {
      status: "new",
      sub_title: 0,
      title: "New",
      action: {
        process: {
          label: "PROCESS NOW",
          value: "process",
        },
        // cancel: {
        //   label: "Cancel",
        //   value: "cancel",
        // },
      },
      active: false,
    },
    {
      status: "process",
      sub_title: 0,
      title: "Process",
      show_code: "order_id",
      request_runner: true,
      print: true,
      show_qr: {
        value: true,
        type: "order",
      },
      action: {
        delivery: {
          label: "DELIVERY",
          value: "delivery",
        },
      },
      active: false,
    },
    {
      status: "ready",
      sub_title: 0,
      title: "Ready for Pickup",
      active: false,
    },
    {
      status: "delivery",
      sub_title: 0,
      title: "On Delivery",
      active: false,
    },
    {
      status: "complete",
      sub_title: 0,
      title: "Complete",
      active: false,
    },
    {
      status: "all",
      sub_title: 0,
      title: "All (Payment Success)",
      active: false,
    },
  ]);
  const [statusActive, setStatusActive] = React.useState(0);

  let tEnd = moment(new Date()).format("YYYY-MM-DD") + " 23:59:59";
  let tStart = moment(new Date()).format("YYYY-MM-DD") + " 00:00:00";
  const [dateRange, setDateRange] = React.useState({
    startDate: moment(tStart).tz("UTC").format(),
    endDate: moment(tEnd).tz("UTC").format(),
    key: "",
  });
  const [isLoading, setIsLoading] = React.useState(false);
  const [search, setSearch] = React.useState("");
  const [pageState, setPageState] = React.useState("");
  const [pageFilter, setPageFilter] = React.useState({
    num: 10,
    cursor:
      pageState?.headers && pageState?.headers["x-cursor"]
        ? pageState?.headers["x-cursor"]
        : "",
    keyword: search,
    date_start: dateRange.startDate,
    date_end: dateRange.endDate,
    progress:
      arrStatus[statusActive]?.status === "all"
        ? ""
        : arrStatus[statusActive]?.status,
    property_id: "",
  });
  const [openModal, setOpenModal] = React.useState(false);
  const [activeDetailData, setActiveDetailData] = React.useState("");
  const [downloading, setDownloading] = React.useState(false);
  const loadMoreBtnRef = React.useRef("");

  const queryClient = new QueryClient();

  const handleToggleModal = () => {
    setOpenModal(!openModal);
  };

  const chatToCustomer = React.useCallback((transaction) => {
    const phone = `62${transaction.user.phone.substring(1)}`;
    let message = `*${transaction.unique_id}*%0a${transaction.orders[0].tenant.property.name} - ${transaction.orders[0].tenant.name}%0a%0aHalo ${transaction.user.name} `;
    const url = `https://api.whatsapp.com/send?phone=${phone}&text=${message.replace(
      / /g,
      "%20"
    )}`;
    if (!window.open(url, "_blank")) {
      window.location.replace(url);
    }
  }, []);

  const toggleStatus = (index) => {
    setStatusActive(index);
    setPageFilter({
      ...pageFilter,
      cursor: "",
      progress:
        arrStatus[index]?.status === "all" ? "" : arrStatus[index]?.status,
    });
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleDateChange = (val) => {
    let endDate = moment(val.endDate).format("YYYY-MM-DD") + " 23:59:59";
    let tStart = moment(val.startDate).tz("UTC").format();
    let tEnd = moment(endDate).tz("UTC").format();
    setDateRange({
      startDate: tStart,
      endDate: tEnd,
      key: val.key,
    });
    setPageFilter({
      ...pageFilter,
      cursor: "",
      date_start: tStart,
      date_end: tEnd,
    });
  };

  const getSummaryOrders = useQuery(
    ["sumarryOrders", pageFilter],
    () => {
      return OrderService.getSummary(pageFilter)
        .then((res) => res)
        .catch((error) => {
          handleError(error);
        });
    },
    {
      cacheTime: 0,
      onSuccess: (data) => {
        const items = data?.data;

        const getTotalData = (status) => {
          if (status !== "all") {
            const find = items?.find((item) => item.status === status);

            if (find) {
              return find.total_data;
            } else {
              return 0;
            }
          } else {
            let totalData = items?.reduce(
              (total, item) =>
                item.status !== "unpaid" ? total + item.total_data : total + 0,
              0
            );

            return totalData;
          }
        };

        const remapArrstatus = arrStatus?.map((item) => ({
          ...item,
          sub_title: getTotalData(item.status),
          active: getTotalData(item.status) > 0 ? true : false,
        }));

        setArrStatus(remapArrstatus);
      },
    }
  );

  const getListOrders = useQuery(
    ["listOrders", pageFilter],
    () => {
      setIsLoading(true);
      return pageFilter?.progress !== "unpaid"
        ? OrderService.getList(pageFilter)
            .then((res) => res)
            .catch((error) => {
              handleError(error);
            })
        : OrderService.getListUnpaid(pageFilter)
            .then((res) => res)
            .catch((error) => {
              handleError(error);
            });
    },
    {
      cacheTime: 0,
      enabled: !!getSummaryOrders.data && !getSummaryOrders?.isLoading,
      onSuccess: (data) => {
        const headers = data?.headers;
        const items = data?.data || [];
        const existingItems = pageState?.list || [];

        if (
          pageState?.config &&
          pageState?.config?.url &&
          pageState?.config?.url !== data?.config?.url &&
          items.length > 0
        ) {
          if (
            pageState?.headers &&
            pageState?.headers["x-cursor"] &&
            pageState?.headers["x-cursor"] !== headers["x-cursor"] &&
            pageFilter.cursor !== ""
          ) {
            setPageState({
              ...data,
              list: existingItems?.concat(items),
            });
          } else {
            setPageState({
              ...data,
              list: items,
            });
          }
        } else if (!pageState?.config) {
          setPageState({
            ...data,
            list: items,
          });
        } else {
          if (pageState?.data !== items) {
            setPageState({
              ...data,
              list: items,
            });
          }
        }
      },
      onSettled: (data) => {
        setIsLoading(false);
      },
    }
  );

  const getDetailOrderLog = useQuery(
    ["getDetailOrderLog", activeDetailData],
    () => {
      return OrderService.getDetailOrderLog(activeDetailData?.orders[0]?.id)
        .then((res) => res)
        .catch((error) => {
          handleError(error);
        });
    },
    {
      cacheTime: 0,
      enabled: false,
      onSuccess: (data) => {
        const items = data?.data || [];

        setActiveDetailData({
          ...activeDetailData,
          order_logs: items,
        });
      },
      onError: (err) => {
        setActiveDetailData({
          ...activeDetailData,
          order_logs: [],
        });
      },
      onSettled: (data) => {
        setOpenModal(true);
      },
    }
  );

  const mutationPatchOrder = useMutation(
    (params) => {
      OrderService.patchData(params.id, params.reqBody);
    },
    {
      onMutate: () => {
        queryClient.cancelQueries("summaryOrders");
        queryClient.cancelQueries("listOrders");
      },
      onError: (error, variables, context) => {
        handleError(error);
      },
      onSuccess: (data, variables, context) => {
        setPageFilter({
          ...pageFilter,
          cursor: "",
        });
        getSummaryOrders.refetch();
        getListOrders.refetch();

        notifUtils("Successfully Update Order", "success");
      },
    }
  );

  const handleOpenModal = (transaction) => {
    setActiveDetailData(transaction);
  };

  const handleUpdateProgress = async (order, action) => {
    if (await confirm(action.label, action.message)) {
      let params = {
        id: order.id,
        reqBody: [
          {
            op: "replace",
            path: "/progress",
            value: action.status,
          },
        ],
      };

      mutationPatchOrder.mutate(params);
    }
  };

  const handleUpdateRunnerRequest = async (order, action) => {
    if (await confirm(action.label, action.message)) {
      let params = {
        id: order.id,
        reqBody: [
          {
            op: order?.runner_request ? "replace" : "add",
            path: "/runner_request",
            value: action.status,
          },
        ],
      };

      mutationPatchOrder.mutate(params);
    }
  };

  const handleShowQR = async (unique_id, order) => {
    if (await showQRCodeDialog(unique_id, order)) {
      getSummaryOrders.refetch();
      getListOrders.refetch();
    } else {
      getSummaryOrders.refetch();
      getListOrders.refetch();
    }
  };

  const handleDownloadTransactionOrder = () => {
    setDownloading(true);
    let status = arrStatus[statusActive]["status"];
    var params = {
      property_id: "",
      progress: status === "all" ? "" : status,
      keyword: search,
      sort: "oldest",
      date_start: pageFilter.date_start,
      date_end: pageFilter.date_end,
    };

    OrderService.downloadTransactionOrder(params)
      .then((response) => {
        setDownloading(false);
        const data = response.data;
        var temp =
          "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
          encodeURIComponent(data.content);
        var download = document.createElement("a");
        download.href = temp;
        download.download = data.file_name;
        document.body.appendChild(download);
        download.click();
        document.body.removeChild(download);
      })
      .catch((error) => {
        setDownloading(false);
        handleError(error);
      });
  };

  const handleClickPrint = async (unique_id, order) => {
    OrderService.getPrintOrderTemplate(order?.id)
      .then((res) => {
        showPrintOrderDialog(`${unique_id}-${order?.tenant?.id}`, res.data);
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const handleLoadMore = () => {
    setPageFilter({
      ...pageFilter,
      cursor: pageState?.headers["x-cursor"],
    });
  };

  React.useEffect(() => {
    if (user?.operational?.level === 3) {
      let existingArr = arrStatus;
      existingArr.push({
        status: "unpaid",
        sub_title: "",
        title: "Waiting Payment",
        active: false,
      });

      setArrStatus(existingArr);
    }
  }, [user]);

  React.useEffect(() => {
    if (activeDetailData !== "" && !activeDetailData.order_logs) {
      if (pageFilter?.progress !== "unpaid") {
        getDetailOrderLog.refetch();
      } else {
        setOpenModal(true);
      }
    }
  }, [activeDetailData]);

  React.useEffect(() => {
    // Add delay in search
    const timeout = setTimeout(() => {
      setPageFilter({
        ...pageFilter,
        cursor: "",
        keyword: search,
      });
    }, 500);

    return () => clearTimeout(timeout);
  }, [search]);

  return (
    <BaseLayout background="gray">
      <div className="row mx-0 w-100">
        <div className="col-12 px-0">
          <h3 className="font-16 font-bold mb-0">Order / Orders</h3>
        </div>
        <div className="col-12 px-0">
          <div className="card rounded-8px border-0 mt-4">
            <div className="card-body border-0 px-4 pt-4 pb-0">
              <div className="w-100 d-flex flex-wrap justify-content-start align-items-center">
                <BootstrapInputSearch
                  placeholder="Search Transaction"
                  onChange={(e) => handleSearch(e)}
                />
                <DateRangePickerFilter
                  onChange={(val) => handleDateChange(val)}
                  defaultDate={dateRange}
                  maxDate={new Date()}
                  label="Lihat Transaksi:"
                  iconPosition="right"
                  style={
                    width === "lg" || width === "xl" || width === "md"
                      ? { marginLeft: 12 }
                      : { marginLeft: 0, marginTop: 12 }
                  }
                />
                {width !== "sm" &&
                  width !== "xs" &&
                  pageFilter?.progress !== "unpaid" && (
                    <button
                      type="button"
                      className="btn btn-blue font-bold ml-auto"
                      onClick={() => handleDownloadTransactionOrder()}
                      disabled={downloading}
                    >
                      Export to excel
                    </button>
                  )}
              </div>
              <p className="font-12 font-bold my-3">Status</p>
              <IzyTabsPanel
                tabs={arrStatus}
                tabActive={statusActive}
                onClick={(index) => toggleStatus(index)}
              />
            </div>
            <div className="card-body border-0 px-4 pt-0 pb-4">
              <p className="font-12 font-bold my-3">Order Lists</p>
              {pageState?.list?.length > 0 &&
                pageState?.list?.map((transaction, key) => (
                  <ListRowPanel
                    arrStatus={arrStatus}
                    status={arrStatus[statusActive]}
                    transaction={transaction}
                    key={transaction?.orders[0]?.id}
                    number={key + 1}
                    handleChat={chatToCustomer}
                    access={access}
                    handleOpenModal={handleOpenModal}
                    handleUpdateProgress={handleUpdateProgress}
                    handleShowQR={handleShowQR}
                    handleUpdateRunnerRequest={handleUpdateRunnerRequest}
                    handleClickPrint={handleClickPrint}
                  />
                ))}
              {(getListOrders?.isLoading || isLoading) &&
                Array.from(new Array(5)).map((val, key) => (
                  <ListRowLoadingPanel key={key} />
                ))}
              {!getListOrders?.isLoading &&
                !isLoading &&
                pageState?.headers &&
                pageState?.headers["x-cursor"] &&
                pageState?.headers["x-cursor"] !== "" &&
                arrStatus[statusActive].sub_title > pageState?.list?.length && (
                  <div className="w-100 text-center">
                    <button
                      type="button"
                      className="btn btn-blue px-3 mt-3"
                      onClick={() => handleLoadMore()}
                      ref={loadMoreBtnRef}
                    >
                      Load More
                    </button>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
      {activeDetailData !== "" && (
        <DetailPanel
          openModal={openModal}
          transaction={activeDetailData}
          handleToggle={handleToggleModal}
          arrStatus={arrStatus}
        />
      )}
      {(width === "sm" || width === "xs") &&
        pageFilter?.progress !== "unpaid" && (
          <StyledFAB
            color="primary"
            onClick={() => handleDownloadTransactionOrder()}
            disabled={downloading}
          >
            <ImportExportIcon />
          </StyledFAB>
        )}
    </BaseLayout>
  );
};

export default withWidth()(NewOrder);
